/* eslint-disable max-len */
import React from 'react';

const ErrorIcon = ({ width = '15px', height = '16px', fill = '#C64242' }) => (
  <svg width={width} height={height} viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.25 8.69261H6.75V4.18077H8.25V8.69261ZM8.25 11.7005H6.75V10.1966H8.25V11.7005ZM7.5 0.420898C6.51509 0.420898 5.53982 0.615402 4.62987 0.993305C3.71993 1.37121 2.89314 1.92511 2.1967 2.62338C0.790176 4.0336 0 5.94628 0 7.94064C0 9.935 0.790176 11.8477 2.1967 13.2579C2.89314 13.9562 3.71993 14.5101 4.62987 14.888C5.53982 15.2659 6.51509 15.4604 7.5 15.4604C9.48912 15.4604 11.3968 14.6681 12.8033 13.2579C14.2098 11.8477 15 9.935 15 7.94064C15 6.95313 14.806 5.97529 14.4291 5.06296C14.0522 4.15062 13.4997 3.32165 12.8033 2.62338C12.1069 1.92511 11.2801 1.37121 10.3701 0.993305C9.46018 0.615402 8.48491 0.420898 7.5 0.420898Z" fill={fill} />
  </svg>
);

export default ErrorIcon;
